import React from "react";
import { styled } from "@mui/material/styles";
import borderBack from "../../../assets/images/borderBack.png";
import requestdelivery from "../../../assets/images/requestdelivery.png";
import requestroute from "../../../assets/images/requestroute.png";
import { Link } from "react-router-dom";
import GoogleMap from "../../shared/map";
import { useNavigate } from "react-router-dom";

const DeliveryTypeMain = styled("div")(({ theme }) => ({
  height: "100vh",
  minHeight: "100vh",
  width: "100%",
  position: "relative",
  zIndex: 3,
}));

const PackageDeliveryBox = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "20px",
  left: "10%",
  transform: "translateX(-10%)",
  width: "70%",
  maxWidth: "450px",
  zIndex: 1,
  backgroundColor: "#fff",
  boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
  padding: "40px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    maxWidth: "100%",
    top: "inherit",
    bottom: 0,
    boxShadow: "0px -1px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "20px 20px 0px 0px",
    marginBottom: "0px",
    padding: "20px",
  },
}));

const Linked = styled(Link)(({ theme }) => ({ height: "50px" }));
const Header = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "20px",
  [theme.breakpoints.down("sm")]: {
    "& .linkedMain img": {
      width: "40px",
      height: "40px",
    },
  },
}));
const Maincontant = styled("div")(({ theme }) => ({
  "& h6": {
    ...theme.authTitle,
    marginBottom: "2px",
  },
  "& p": {
    ...theme.authsubTit,
    marginBottom: "20px",
    fontSize: "16px",
    lineHeight: "24px",
    color: "rgba(11, 11, 11, 0.6)",
  },
  [theme.breakpoints.down("sm")]: {
    "& h6": { fontSize: "16px", marginBottom: "5px", lineHeight: "16px" },
  },
}));
const PaymentMethodBtn = styled("div")(({ theme }) => ({
  "& img": { width: "30px", height: "30px" },
  margin: "15px 0",
  gap: "10px",
  display: "flex",
  padding: "10px",
  background: "#F2F2F2",
  borderRadius: "12px",
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "25px",
  color: "#0B0B0B",
  cursor: "pointer",
  alignItems: "center",
}));

const ButtonsMain = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    marginLeft: "3.5rem",
  },
}));

const DeliveryType = () => {
  const navigate = useNavigate();
  return (
    <DeliveryTypeMain>
      <GoogleMap LocationIcon={true} />
      <PackageDeliveryBox>
        <Header>
          <Linked to="/delivery-home" className="linkedMain">
            <img src={borderBack} alt="Linkarrow" />
          </Linked>
          <Maincontant>
            <h6>Delivery Type</h6>
            <p>Select your desired type for delivery</p>
          </Maincontant>
        </Header>
        <ButtonsMain>
          <PaymentMethodBtn onClick={() => navigate("/delivery-steps")}>
            <img src={requestdelivery} alt="requestdelivery" />
            <div className="PaymentMethodBtnText">Request a Delivery</div>
          </PaymentMethodBtn>
          {/* <PaymentMethodBtn onClick={() => navigate("/route-stop-one")}> */}
          <PaymentMethodBtn onClick={() => navigate("/route-steps")}>
            <img src={requestroute} alt="ach" />
            <div className="PaymentMethodBtnText">Request a route</div>
          </PaymentMethodBtn>
        </ButtonsMain>
      </PackageDeliveryBox>
    </DeliveryTypeMain>
  );
};

export default DeliveryType;
